import { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid } from '@mui/material'

import Select from './Select'
import InputField from './InputField'
import Dialog from './Dialog'
import { config } from '../settings/configs'
import {
  colours,
  titlesIscrizioni,
  titlesCalendari,
  SQUADRA_INVIO_RISULTATO,
} from '../settings/settings'
import {
  errorPunteggioSet,
  errorPunteggioSetN,
  errorPunteggioGoldenSet,
  errorPunteggioMini,
  errorSetMini,
} from '../hooks/error-functions'
import { getCategorie } from '../hooks/selection-get-functions'
import { sortCategorie, sortNumeriGara } from '../hooks/sort-functions'
import {
  useGetCalendariQuery,
  useGetCalendarioByIdQuery,
  useGetCalendariBySfidaMutation,
  useGetCategorieQuery,
  useGetImpostazioniAvanzateQuery,
  useGetImpostazioniContattiQuery,
  useGetIscrizioniQuery,
} from '../hooks/api-slice'
import {
  fromStringsToDateTime,
  isObjectId,
  mailTo,
  setWinningScore,
  useTeamName,
} from '../hooks/utils-functions'
import { setError } from '../container/home'

const AVANZ_FIELDS = ['SquadraInvioRisultato', 'SquadraInvioRisultatoFinali']

const DialogRisultato = ({ open, handleClose, triggerFunction, gara }) => {
  const { admin, societa, omologatore, codiceUtente } = useSelector(
    state => state.home.infoUtente,
  )
  const { data: avanzate } = useGetImpostazioniAvanzateQuery(AVANZ_FIELDS)
  const { data: contatti } = useGetImpostazioniContattiQuery()
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )
  const selectedCampionatoGironiPubblicati = useSelector(
    state => state.selection.selectedCampionatoGironiPubblicati,
  )

  const { data: iscrizioniLight } = useGetIscrizioniQuery(
    { campionato: selectedCampionato, iFilter: 'light' },
    { skip: !(selectedCampionato && selectedCampionatoGironiPubblicati) },
  )
  const { data: categorie } = useGetCategorieQuery()
  const { data: availableGare } = useGetCalendariQuery(
    { selectedCampionato, codiceUtente, tipologia: 'risultato' },
    { skip: !(selectedCampionato && codiceUtente) },
  )

  const squadraRisultatoGironi =
    SQUADRA_INVIO_RISULTATO?.[avanzate?.SquadraInvioRisultato]?.label
  const squadraRisultatoFinali =
    SQUADRA_INVIO_RISULTATO?.[avanzate?.SquadraInvioRisultatoFinali]?.label

  const [selectedGara, setSelectedGara] = useState()
  const [risultato, setRisultato] = useState()

  const { data: cal } = useGetCalendarioByIdQuery(selectedGara, {
    skip: !selectedGara,
  })

  const [getCalendariBySfidaMutation] = useGetCalendariBySfidaMutation()

  const dispatch = useDispatch()

  const setRisultatoField = useCallback(
    (field, value) => setRisultato(prev => ({ ...prev, [field]: value })),
    [],
  )

  const [availableCategorie, setAvailableCategorie] = useState()
  const [availableSquadre, setAvailableSquadre] = useState()
  const [availableGareTeam, setAvailableGareTeam] = useState()
  const [selectedCategoria, setSelectedCategoria] = useState()
  const [selectedSquadra, setSelectedSquadra] = useState()

  // state to manage scores
  const [setVintiCasa, setSetVintiCasa] = useState()
  const [setVintiTrasferta, setSetVintiTrasferta] = useState()
  const [puntiVintiCasa, setPuntiVintiCasa] = useState()
  const [puntiVintiTrasferta, setPuntiVintiTrasferta] = useState()

  // state to manage Mini and Propaganda
  const [isMini, setIsMini] = useState()
  const [isPropaganda, setIsPropaganda] = useState()
  const [isPriFin2223, setIsPriFin2223] = useState()

  // states to manage Golden set
  const [garaCurr, setGaraCurr] = useState()
  const [garaPrec, setGaraPrec] = useState()
  const [isReturn, setIsReturn] = useState()
  const [setVintiCasaPrec, setSetVintiCasaPrec] = useState()
  const [setVintiTrasfertaPrec, setSetVintiTrasfertaPrec] = useState()
  const [penalitaCasaPrec, setPenalitaCasaPrec] = useState()
  const [penalitaTrasfertaPrec, setPenalitaTrasfertaPrec] = useState()
  const [penalitaCasaCurr, setPenalitaCasaCurr] = useState()
  const [penalitaTrasfertaCurr, setPenalitaTrasfertaCurr] = useState()
  const [needsGoldenSet, setNeedsGoldenSet] = useState()

  // error functions
  const fErrorSetMini = () =>
    errorSetMini(risultato?.setVintiCasaMini, risultato?.setVintiTrasfertaMini)
  const fErrorPunteggioMini = () =>
    errorPunteggioMini(risultato?.parzialiCasa, risultato?.parzialiTrasferta)
  const fErrorPunteggioSetN = n =>
    errorPunteggioSetN(
      risultato?.parzialiCasa,
      risultato?.parzialiTrasferta,
      n,
      setVintiCasa,
      setVintiTrasferta,
      isPropaganda,
      isPriFin2223,
    )
  const fErrorPunteggioGoldenSet = () =>
    errorPunteggioGoldenSet(
      risultato?.parzialeGoldenCasa,
      risultato?.parzialeGoldenTrasferta,
      isPropaganda,
      isPriFin2223,
    )

  const tGara =
    admin || omologatore
      ? gara
      : availableGareTeam?.find(c => c._id === selectedGara)

  const squadraCasaName = useTeamName(tGara?.squadraCasaID)
  const squadraTrasfertaName = useTeamName(tGara?.squadraTrasfertaID)

  // Set categorie
  useEffect(() => {
    if (open) setAvailableCategorie(getCategorie(availableGare))
  }, [availableGare, open])

  // Set squadre
  useEffect(() => {
    if (availableGare && iscrizioniLight && selectedCategoria)
      setAvailableSquadre(
        availableGare
          ?.filter(a => a.categoria === selectedCategoria)
          ?.map(a => a.squadreInvioRisultato)
          ?.flat()
          ?.filter((v, i, s) => s.indexOf(v) === i)
          ?.filter(isObjectId)
          ?.filter(
            i =>
              iscrizioniLight?.find(x => x._id === i)?.codiceSocieta ===
              Number(codiceUtente),
          )
          ?.sort((a, b) => sortCategorie(a.categoria, b.categoria)),
      )
  }, [availableGare, codiceUtente, iscrizioniLight, selectedCategoria])

  // Set gare
  useEffect(() => {
    setAvailableGareTeam(
      availableGare
        ?.filter(a => a.squadreInvioRisultato?.includes(selectedSquadra))
        ?.sort((a, b) => sortNumeriGara(a.numeroGara, b.numeroGara)),
    )
  }, [availableGare, selectedSquadra])

  // Set gara
  useEffect(() => {
    setSelectedGara(
      admin || omologatore
        ? gara?._id
        : availableGareTeam?.length === 1
          ? availableGareTeam[0]?._id
          : undefined,
    )

    setRisultato(
      gara
        ? {
            parzialiCasa: gara?.parzialiCasa,
            parzialiTrasferta: gara?.parzialiTrasferta,
            setVintiCasaMini: gara?.setVintiCasa,
            setVintiTrasfertaMini: gara?.setVintiTrasferta,
            parzialeGoldenCasa: gara?.parzialeGoldenCasa,
            parzialeGoldenTrasferta: gara?.parzialeGoldenTrasferta,
          }
        : undefined,
    )
  }, [admin, availableGareTeam, gara, omologatore])

  // set isMini, isPropaganda and Primaverile 2022/2023 Finali
  useEffect(() => {
    const tCategoria = categorie?.find(c => c.categoria === cal?.categoria)
    setIsMini(tCategoria?.isMini)
    setIsPropaganda(tCategoria?.isPropaganda)
    setIsPriFin2223(
      cal?.codiceCampionato === 'primaverile_2022-2023' &&
        cal?.girone === 'finali',
    )
  }, [cal, categorie])

  // Set setVinti
  useEffect(() => {
    setSetVintiCasa(
      (isMini
        ? risultato?.setVintiCasaMini
        : risultato?.parzialiCasa?.filter(
            (p, i) =>
              !errorPunteggioSet(
                risultato?.parzialiCasa?.[i],
                risultato?.parzialiTrasferta?.[i],
                setWinningScore(i + 1, isPropaganda, isPriFin2223),
              ) && p > risultato?.parzialiTrasferta?.[i],
          )?.length) || 0,
    )
    setSetVintiTrasferta(
      (isMini
        ? risultato?.setVintiTrasfertaMini
        : risultato?.parzialiTrasferta?.filter(
            (p, i) =>
              !errorPunteggioSet(
                risultato?.parzialiCasa?.[i],
                risultato?.parzialiTrasferta?.[i],
                setWinningScore(i + 1, isPropaganda, isPriFin2223),
              ) && p > risultato?.parzialiCasa?.[i],
          )?.length) || 0,
    )
  }, [isMini, isPriFin2223, isPropaganda, risultato])

  // Set puntiVinti
  useEffect(() => {
    setPuntiVintiCasa(
      risultato?.parzialiCasa
        ?.filter(
          (_, i) =>
            isMini ||
            !errorPunteggioSet(
              risultato?.parzialiCasa?.[i],
              risultato?.parzialiTrasferta?.[i],
              setWinningScore(i + 1, isPropaganda, isPriFin2223),
            ),
        )
        ?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0,
    )
    setPuntiVintiTrasferta(
      risultato?.parzialiTrasferta
        ?.filter(
          (_, i) =>
            isMini ||
            !errorPunteggioSet(
              risultato?.parzialiCasa?.[i],
              risultato?.parzialiTrasferta?.[i],
              setWinningScore(i + 1, isPropaganda, isPriFin2223),
            ),
        )
        ?.reduce((a, b) => (a || 0) + (b || 0), 0) || 0,
    )
  }, [isMini, isPriFin2223, isPropaganda, risultato])

  // set garaCurr and garaPrec
  useEffect(() => {
    const fetchGaraCurrPrec = async () => {
      try {
        // get matches of the current "sfida"
        const { id, codiceCampionato, categoria, sfidaTabellone } = cal
        if (sfidaTabellone) {
          const arg = { codiceCampionato, categoria, sfidaTabellone }
          const { data: sfidaData } = await getCalendariBySfidaMutation(arg)
          if (!sfidaData) {
            dispatch(setError('Impossibile trovare le partite della sfida.'))
          } else {
            if (sfidaData.length === 2) {
              // check teamIDs
              if (
                [
                  sfidaData[0]?.squadraCasaID,
                  sfidaData[0]?.squadraTrasfertaID,
                ].every(i =>
                  [
                    sfidaData[1]?.squadraCasaID,
                    sfidaData[1]?.squadraTrasfertaID,
                  ].includes(i),
                )
              ) {
                setGaraCurr(sfidaData.find(s => s.id === id))
                setGaraPrec(sfidaData.find(s => s.id !== id))
              }
            } else {
              setGaraCurr()
              setGaraPrec()
            }
          }
        }
      } catch (err) {
        console.log(err)
        dispatch(setError(err.message))
      }
    }

    if (cal) {
      fetchGaraCurrPrec()
    } else {
      setGaraCurr()
      setGaraPrec()
    }
  }, [cal, dispatch, getCalendariBySfidaMutation])

  // update setVintiPrec, penalitaPrec, penalitaCurr
  useEffect(() => {
    if (garaCurr && garaPrec) {
      const sameCasaTrasferta =
        garaCurr.squadraCasaID === garaPrec.squadraCasaID &&
        garaCurr.squadraTrasfertaID === garaPrec.squadraTrasfertaID

      if (sameCasaTrasferta) {
        setSetVintiCasaPrec(garaPrec.setVintiCasa)
        setSetVintiTrasfertaPrec(garaPrec.setVintiTrasferta)
        setPenalitaCasaPrec(garaPrec.penalitaCasa)
        setPenalitaTrasfertaPrec(garaPrec.penalitaTrasferta)
      } else {
        setSetVintiCasaPrec(garaPrec.setVintiTrasferta)
        setSetVintiTrasfertaPrec(garaPrec.setVintiCasa)
        setPenalitaCasaPrec(garaPrec.penalitaTrasferta)
        setPenalitaTrasfertaPrec(garaPrec.penalitaCasa)
      }

      setPenalitaCasaCurr(garaCurr.penalitaCasa)
      setPenalitaTrasfertaCurr(garaCurr.penalitaTrasferta)
    } else {
      setSetVintiCasaPrec()
      setSetVintiTrasfertaPrec()
      setPenalitaCasaPrec()
      setPenalitaTrasfertaPrec()
      setPenalitaCasaCurr()
      setPenalitaTrasfertaCurr()
    }
  }, [garaCurr, garaPrec])

  // update isReturn
  useEffect(() => {
    setIsReturn(
      garaCurr?.data &&
        garaCurr?.ora &&
        garaPrec?.data &&
        garaPrec?.ora &&
        fromStringsToDateTime(garaCurr.data, garaCurr.ora) >=
          fromStringsToDateTime(garaPrec.data, garaPrec.ora),
    )
  }, [garaCurr, garaPrec])

  // update needsGoldenSet
  useEffect(() => {
    if (isReturn) {
      const puntiCasa =
        setVintiCasa +
        setVintiCasaPrec -
        (penalitaCasaCurr || 0) -
        (penalitaCasaPrec || 0)

      const puntiTrasferta =
        setVintiTrasferta +
        setVintiTrasfertaPrec -
        (penalitaTrasfertaCurr || 0) -
        (penalitaTrasfertaPrec || 0)

      if (puntiCasa === puntiTrasferta) {
        setNeedsGoldenSet(true)
      } else {
        setNeedsGoldenSet(false)
        setRisultatoField('parzialeGoldenCasa')
        setRisultatoField('parzialeGoldenTrasferta')
      }
    }
  }, [
    isReturn,
    penalitaCasaCurr,
    penalitaCasaPrec,
    penalitaTrasfertaCurr,
    penalitaTrasfertaPrec,
    setRisultatoField,
    setVintiCasa,
    setVintiCasaPrec,
    setVintiTrasferta,
    setVintiTrasfertaPrec,
  ])

  useEffect(() => {
    if (!open) {
      setSelectedCategoria()
      setSelectedSquadra()
      setRisultato()
      setSelectedGara()
    }
  }, [open])

  const GridWarning = ({ text }) => (
    <Grid size={12}>
      <center>
        <b>
          <i>{text}</i>
        </b>
      </center>
    </Grid>
  )

  const mainContainerProps = {
    container: true,
    spacing: 1,
    alignItems: 'baseline',
    sx: { width: '100%' },
  }

  const rowContainerProps = {
    container: true,
    spacing: 2,
    alignItems: 'center',
    justifyContent: 'center',
    sx: { width: '100%' },
  }

  const inputProps = {
    type: 'number',
    align: 'center',
    mode: admin || omologatore ? 'update' : undefined,
  }

  const goldenStyle = { paddingBottom: 20, backgroundColor: colours.goldenSet }

  const fColor = (isError, isUndefined) =>
    (isError && colours.redLight) ||
    (isUndefined && colours.greyLight) ||
    colours.black

  const updateParziali = (p, n, i) => {
    if (!p) return [...new Array(n - 1).fill(undefined), i]

    if (p.length >= n)
      return [
        ...p.filter((_, x) => x < n - 1),
        i,
        ...p.filter((_, x) => x > n - 1),
      ]

    return [...p, ...new Array(n - p.length - 1).fill(undefined), i]
  }

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(selectedGara, risultato)}
      title={
        admin
          ? titlesCalendari.titleEditRisultato
          : titlesIscrizioni.titleRisultato
      }
      textConfirm={admin ? 'Salva' : 'Conferma'}
      maxWidth='md'
      stretchHeight={!admin}
    >
      <Grid container spacing={3} sx={{ width: '100%' }}>
        {societa &&
          (((!iscrizioniLight || iscrizioniLight.length === 0) && (
            <Grid size={12}>Nessuna squadra iscritta a questo campionato.</Grid>
          )) || (
            <Grid container sx={{ width: '100%' }}>
              <Grid size={12}>
                Il presente modulo permette di comunicare i risultati delle
                gare.
                <br />
                Nelle fasi a gironi il risultato deve essere comunicato dalla{' '}
                {squadraRisultatoGironi?.toLowerCase()}, nelle fasi a
                eliminazione dalla {squadraRisultatoFinali?.toLowerCase()}.
                <br />
                <br />
                Non è possibile inviare i risultati per le gare:
                <ul>
                  <li>calendarizzate nel futuro,</li>
                  <li>rimandate a data da destinarsi (cioè senza data),</li>
                  {config?.features?.spostamenti && (
                    <li>con spostamento in sospeso,</li>
                  )}
                  <li>con risultato già presente.</li>
                </ul>
                Per domande o chiarimenti scrivere a{' '}
                {mailTo(contatti?.MailRisultati)}.
              </Grid>
              {((!availableGare || availableGare.length === 0) && (
                <GridWarning text='Nessun risultato da inviare.' />
              )) || (
                <>
                  <Grid size={{ xs: 12, md: 4 }}>
                    <Select
                      label='Categoria'
                      value={selectedCategoria}
                      options={availableCategorie}
                      onChange={setSelectedCategoria}
                      disabled={!availableCategorie}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Select
                      label='Squadra'
                      value={selectedSquadra}
                      options={availableSquadre}
                      optionLabels={availableSquadre?.map(
                        x =>
                          iscrizioniLight?.find(i => i.id === x)?.nomeSquadra,
                      )}
                      onChange={setSelectedSquadra}
                      disabled={!selectedCategoria || !availableSquadre}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 2 }}>
                    <Select
                      label='Gara'
                      value={selectedGara}
                      options={availableGareTeam?.map(i => i._id)}
                      optionLabels={availableGareTeam?.map(i => i.numeroGara)}
                      onChange={i => {
                        setSelectedGara(i)
                        setRisultato()
                      }}
                      disabled={!selectedSquadra || !availableGareTeam}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          ))}
        {selectedGara && (
          <Grid container alignItems='center' sx={{ width: '100%' }}>
            <Grid size={6}>
              <center>
                <b>{squadraCasaName}</b>
              </center>
            </Grid>
            <Grid size={6}>
              <center>
                <b>{squadraTrasfertaName}</b>
              </center>
            </Grid>
          </Grid>
        )}
        {selectedGara && (
          <Grid container sx={{ width: '100%' }}>
            <>
              {(isMini && (
                <Grid {...mainContainerProps}>
                  <Grid {...rowContainerProps}>
                    <Grid size={{ xs: 'grow', md: 2 }}>
                      <center>
                        <InputField
                          id='setVintiCasaMini'
                          value={risultato?.setVintiCasaMini}
                          onChange={i =>
                            setRisultatoField('setVintiCasaMini', i)
                          }
                          autoFocus
                          errorFunc={fErrorSetMini}
                          {...inputProps}
                        />
                      </center>
                    </Grid>
                    <Grid size={{ xs: 3, md: 4 }}>
                      <center
                        style={{
                          color: fColor(
                            fErrorSetMini(),
                            risultato?.setVintiCasaMini === undefined ||
                              risultato?.setVintiTrasfertaMini === undefined,
                          ),
                        }}
                      >
                        set
                      </center>
                    </Grid>
                    <Grid size={{ xs: 'grow', md: 2 }}>
                      <center>
                        <InputField
                          id='setVintiTrasfertaMini'
                          value={risultato?.setVintiTrasfertaMini}
                          onChange={i =>
                            setRisultatoField('setVintiTrasfertaMini', i)
                          }
                          errorFunc={fErrorSetMini}
                          {...inputProps}
                        />
                      </center>
                    </Grid>
                  </Grid>
                  {[1].map(n => (
                    <Grid key={n} {...rowContainerProps}>
                      <Grid size={{ xs: 'grow', md: 2 }}>
                        <center>
                          <InputField
                            id='parzialiCasa'
                            value={risultato?.parzialiCasa?.[n - 1]}
                            onChange={i =>
                              setRisultatoField(
                                'parzialiCasa',
                                updateParziali(risultato?.parzialiCasa, n, i),
                              )
                            }
                            errorFunc={fErrorPunteggioMini}
                            {...inputProps}
                          />
                        </center>
                      </Grid>
                      <Grid size={{ xs: 3, md: 4 }}>
                        <center
                          style={{
                            color: fColor(
                              fErrorPunteggioMini(),
                              risultato?.parzialiCasa?.[n - 1] === undefined ||
                                risultato?.parzialiTrasferta?.[n - 1] ===
                                  undefined,
                            ),
                          }}
                        >
                          punti
                        </center>
                      </Grid>
                      <Grid size={{ xs: 'grow', md: 2 }}>
                        <center>
                          <InputField
                            id='parzialiTrasferta'
                            value={risultato?.parzialiTrasferta?.[n - 1]}
                            onChange={i =>
                              setRisultatoField(
                                'parzialiTrasferta',
                                updateParziali(
                                  risultato?.parzialiTrasferta,
                                  n,
                                  i,
                                ),
                              )
                            }
                            errorFunc={fErrorPunteggioMini}
                            {...inputProps}
                          />
                        </center>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )) || (
                <Grid {...mainContainerProps}>
                  {[1, 2, 3, 4, 5].map(n => (
                    <Grid key={n} {...rowContainerProps}>
                      <Grid size={{ xs: 'grow', md: 2 }}>
                        <center>
                          <InputField
                            id={`parzialiCasa-${n}`}
                            value={risultato?.parzialiCasa?.[n - 1]}
                            onChange={i =>
                              setRisultatoField(
                                'parzialiCasa',
                                updateParziali(risultato?.parzialiCasa, n, i),
                              )
                            }
                            autoFocus={n === 1}
                            errorFunc={() => fErrorPunteggioSetN(n)}
                            {...inputProps}
                          />
                        </center>
                      </Grid>
                      <Grid size={{ xs: 3, md: 4 }}>
                        <center
                          style={{
                            color: fColor(
                              fErrorPunteggioSetN(n),
                              risultato?.parzialiCasa?.[n - 1] === undefined ||
                                risultato?.parzialiTrasferta?.[n - 1] ===
                                  undefined,
                            ),
                          }}
                        >
                          {n}° set
                        </center>
                      </Grid>
                      <Grid size={{ xs: 'grow', md: 2 }}>
                        <center>
                          <InputField
                            id={`parzialiTrasferta-${n}`}
                            value={risultato?.parzialiTrasferta?.[n - 1]}
                            onChange={i =>
                              setRisultatoField(
                                'parzialiTrasferta',
                                updateParziali(
                                  risultato?.parzialiTrasferta,
                                  n,
                                  i,
                                ),
                              )
                            }
                            errorFunc={() => fErrorPunteggioSetN(n)}
                            {...inputProps}
                          />
                        </center>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )}
              {isReturn && (
                <Grid {...rowContainerProps} alignItems='stretch'>
                  <Grid size={{ xs: 'grow', md: 2 }} style={goldenStyle}>
                    <center>
                      <InputField
                        id='parzialeGoldenCasa'
                        value={risultato?.parzialeGoldenCasa}
                        onChange={i =>
                          setRisultatoField('parzialeGoldenCasa', i)
                        }
                        disabled={!needsGoldenSet}
                        errorFunc={fErrorPunteggioGoldenSet}
                        {...inputProps}
                      />
                    </center>
                  </Grid>
                  <Grid size={{ xs: 3, md: 4 }} style={goldenStyle}>
                    <center
                      style={{
                        color: fColor(
                          fErrorPunteggioGoldenSet(),
                          !needsGoldenSet,
                        ),
                      }}
                    >
                      Golden set
                    </center>
                  </Grid>
                  <Grid size={{ xs: 'grow', md: 2 }} style={goldenStyle}>
                    <center>
                      <InputField
                        id='parzialeGoldenTrasferta'
                        value={risultato?.parzialeGoldenTrasferta}
                        onChange={i =>
                          setRisultatoField('parzialeGoldenTrasferta', i)
                        }
                        disabled={!needsGoldenSet}
                        errorFunc={fErrorPunteggioGoldenSet}
                        {...inputProps}
                      />
                    </center>
                  </Grid>
                </Grid>
              )}
              <Grid container alignItems='center' sx={{ width: '100%' }}>
                <Grid size={{ xs: 6, md: 3 }}>
                  <center>
                    Risultato
                    <br />
                    <b>{setVintiCasa}</b>
                    &nbsp; - &nbsp;
                    <b>{setVintiTrasferta}</b>
                  </center>
                </Grid>
                <Grid size={{ xs: 6, md: 3 }}>
                  <center>
                    Punteggio
                    <br />
                    <b>{puntiVintiCasa}</b>
                    &nbsp; - &nbsp;
                    <b>{puntiVintiTrasferta}</b>
                  </center>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <center>
                    Squadra vincitrice
                    <br />
                    <b>
                      {setVintiCasa > setVintiTrasferta
                        ? squadraCasaName
                        : setVintiCasa < setVintiTrasferta
                          ? squadraTrasfertaName
                          : isMini &&
                              setVintiCasa &&
                              setVintiTrasferta &&
                              setVintiCasa === setVintiTrasferta
                            ? 'PAREGGIO'
                            : '?'}
                    </b>
                  </center>
                </Grid>
              </Grid>
            </>
          </Grid>
        )}
      </Grid>
    </Dialog>
  )
}

export default DialogRisultato
